import { Separator, Tabs } from "@heroui/react";
import { useSearchParams } from "react-router";
import { readNewsParams, withNewsParams, type NewsTab } from "../features/news/params";
import { Icon, type IconName } from "../components/Icon";
import { NewsLayout } from "../components/NewsLayout";
import { DATE_FILTER_TITLE, SOURCES_TITLE } from "../components/sidebar/panels";
import { MyFeed } from "../features/feeds/MyFeed";
import { LatestNews } from "../features/news/LatestNews";
import { SavedDateFilter, SavedNews } from "../features/news/SavedNews";
import { SourcesPanel, SourceViewHeading } from "../features/news/SourcesPanel";

type TabId = "ultime" | "feed" | "salvate";

/** The tab in the query string (/news?tab=latest|feed|saved) and the panel's id. */
const TAB_OF_PARAM: Record<NewsTab, TabId> = { latest: "ultime", feed: "feed", saved: "salvate" };
const PARAM_OF_TAB: Record<TabId, NewsTab> = { ultime: "latest", feed: "feed", salvate: "saved" };

const TABS: { id: TabId; label: string; icon: IconName }[] = [
  { id: "ultime", label: "Ultime news", icon: "squareArticle" },
  { id: "feed", label: "Il mio feed", icon: "pin" },
  { id: "salvate", label: "News salvate", icon: "bookmark" },
];

export function NewsPage() {
  const [search, setSearch] = useSearchParams();
  const tab: TabId = TAB_OF_PARAM[readNewsParams(search).tab];
  const setTab = (next: TabId) => setSearch(withNewsParams(search, { tab: PARAM_OF_TAB[next] }));

  return (
    <Tabs selectedKey={tab} onSelectionChange={(key) => setTab(key as TabId)} className="flex flex-1 flex-col gap-0">
      <Tabs.ListContainer className="rounded-none bg-transparent">
        <Tabs.List aria-label="Viste news" className="w-auto min-w-0 gap-4 p-0">
          {TABS.map((t) => (
            <Tabs.Tab
              key={t.id}
              id={t.id}
              className="h-auto w-auto gap-2.5 rounded-sm px-2 py-1 text-base leading-7 font-normal text-accent data-[selected=true]:bg-accent-soft data-[selected=true]:font-medium data-[selected=true]:text-accent"
            >
              <Icon name={t.icon} />
              {t.label}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs.ListContainer>
      <Separator className="my-[5.5px] bg-accent" />

      <Tabs.Panel id="ultime" className="flex flex-1 flex-col p-0">
        <NewsLayout sidebar={{ title: SOURCES_TITLE, render: (collapse) => <SourcesPanel onCollapse={collapse} /> }}>
          <SourceViewHeading />
          <LatestNews />
        </NewsLayout>
      </Tabs.Panel>

      <Tabs.Panel id="feed" className="flex flex-1 flex-col p-0">
        <MyFeed />
      </Tabs.Panel>

      <Tabs.Panel id="salvate" className="flex flex-1 flex-col p-0">
        <NewsLayout
          sidebar={{ title: DATE_FILTER_TITLE, render: (collapse) => <SavedDateFilter onCollapse={collapse} /> }}
        >
          <SavedNews />
        </NewsLayout>
      </Tabs.Panel>
    </Tabs>
  );
}
